export default __webpack_public_path__ + "static/avatar-7ad3cf70a13fe3579ec1e39ef5599e1a.webp";